export default class FilterComponent {
  constructor() {
    this.buttons = document.querySelectorAll('[data-filter-button]');
    this.container = document.querySelector('[data-filter-container]');

    this.handleButtonClick();
  }

  handleButtonClick() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.container.classList.toggle('w-100');
      });
    });
  }
}
